import React, { ReactNode } from 'react';
import {Typography} from '@mui/material';

interface ComponentHeadingProps {
    children?: ReactNode,
    sx ?: Object,
    [key: string]: any;
};


const ComponentHeading : React.FC<ComponentHeadingProps> = ({children, sx = {}, ...props}) => (
    <Typography variant="h3" component="h3" data-sb-field-path = "heading" {...props} sx = {sx}>
        {children}
    </Typography>
);

export default ComponentHeading;
